import wixLocation from 'wix-location';
import wixUsers from 'wix-users';

export async function dropdown2_change(event) {
    if ($w('#dropdown2').value === "rsvp") {
        wixLocation.to("https://clients.rsvpevents.co.il/login");
    } else if ($w('#dropdown2').value === "gift") {
        try{
            let user = await wixUsers.promptLogin();
            let userId = user.id;           // "r5me-6fem-45jf-djhe-484349"
            let isLoggedIn = user.loggedIn; // true
            let roles = await user.getRoles();
            wixLocation.to("/gift"); 
            $w('#dropdown2').value = "";
            return user.getEmail();  
        
        } catch (err){
            console.log(err.message);
        }
    }

}